import {
  IonCard,
  IonCardContent,
  IonCol,
  IonGrid,
  IonIcon,
  IonRow,
  IonToast,
} from "@ionic/react";
import {
  EXECUTIONSTATUS,
  MODULES,
  MY_LOAD,
  FETCH_VALUE,
  UN_ASSIGN_DRIVER_CTA_TEXT,
  ASSIGN_DRIVER_CTA_TEXT,
  BUTTONS,
  ERROR_POPUP,
  CARRIER_ASSIGNED_MODULE_WEB,
  START_TRIP_MESSAGE_FOR_PENDING_LOADS,
  TAB,
  EGPSTrackingStatus,
  accept_load_modal_title,
  accept_load_modal_message,
  ACCEPT_ACTION_TYPE,
  ACCEPT_ACTION_QUALIFIER,
  CARRIER_PRO,
  TENDER_ACCEPT_SUCCESS_MESSAGE,
  APPOINTMENT_TOOLTIP_MESSAGE,
  MyLoadsConfigFallback,
  Navigate_Module_Web,
  APPOINTMENT_INDICATOR_STATE_VALUE,
  carrierProErrorLabelFallback,
  CARRIER_PRO_TYPE,
  MODULE_PATHS
} from "../../../utils/constants";
import { EVENT, SCREEN } from "../../../utils/constants.analytics";
import { getSessionId, logEvent } from "../../../utils/Analytics";
import { appointmentState, getAppointmentIndicatorTime, getAppointmentTime } from "../../../utils/formatData";
import getTime from "../../../utils/getTimePeriod";
import React, { useEffect, useMemo, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  LoadTileRight,
  LoadTileMiddle,
  LoadTileMap,
} from "./index";
import "./LoadTile.scss";
import { buyLoadShipmentRequest } from "../../../actions/BookLoad/action";
import { GetShipment } from "../../../models/home/GetShipment.model";
import { AssignDriverDialog } from "../assign-driver/AssignDriverDialog";
import { DriverList } from "../../../models/home/CarrierAssign.model";
import { AssignDriver, loadAssignedData, startTrip, fetchShipments } from "../../../actions/carrierAssign/action";
import { ConfirmDriverDialog } from "../assign-driver/ConfirmDriverDialog";
import { ConfirmStartTrip } from "../start-trip/ConfirmStartTrip";
import { StartTripExicution } from "../../../models/home/StartTripExicution.model";
import { useHistory } from "react-router";
import { ShipmentDetails } from "../shipment-details/shipmentDetails";
import { setNavigation } from "../../../actions/App/action";
import { sortedLoadStops } from "../../../utils/getSortedLoads";
import { StartTripModel } from "../../../models/home/StartTrip.model";
import { getMembersRequestPayload, IONICWrapper } from "../../../utils/common";
import { DriverUnAssignment } from '../unAssign-Driver/driverUnAssignment';
import useOnScreen from "../../../components/ScrollCaptureList/ViewedItems";
import { CustomModalWeb } from "../../pages/userProfile/CustomModalWeb";
import i18n from "../../../../i18n";
import { TenderAction } from "../../../models/myLoad/tenderAction.model";
import { tenderAction } from "../../../actions/carrierTendered/action";
import { ToastMessage } from "../../../utils/ToastMessage";
import { IEShipmentResponse } from "../../../schemas/getShipment/GetShipment.schema";
import { getShipmentDetails as getPayloadforTenderAction } from "../../../selectors/Myload/selector";
import { getCurrentDatewithTimeZone, getCustomer } from "../../../pages/LoadDetails/loadDetailsUtil";
import { MyLoad } from "../../../models/myLoad/myLoad";
import { store } from "../../../store";
import { FetchFromMyLoadConfig } from "../../../utils/MyLoads.util";
import { getStopActivity } from "../../../models/stopActivity.model";
import { ToolTip } from "../../../components/ToolTip/ToolTip";
import { carrierProInputBoxVisibility } from "../../../utils/sourceTMSAndDivisionFilter";


function getDeleveredOnDate(loadStops: any[]) {
  const sortedLoads: any[] = sortedLoadStops(loadStops) || [];
  let actualArrivalDateTime: string = "";
  if (sortedLoads.length > 0) {
    const lastStop: any = sortedLoads[sortedLoads.length - 1];
    actualArrivalDateTime = (lastStop && lastStop.actualArrivalDateTime) || "";
  }
  if (actualArrivalDateTime) {
    const model: StartTripModel = new StartTripModel();
    const date: Date = new Date(model.getTimeForIOS(actualArrivalDateTime));
    actualArrivalDateTime = date.toLocaleDateString("en-GB", {
      month: "short",
      day: "2-digit",
    });
    const dateStr = actualArrivalDateTime.split(" ");
    actualArrivalDateTime = `${dateStr[1]} ${dateStr[0]}`;
  }
  return actualArrivalDateTime;
}

const LoadTile = (props: any) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const [isOpen, openDialog] = useState<boolean>(false);
  const eleRef = useRef<any>(null);
  const isOnScreen = useOnScreen(eleRef);
  const shipmentDetails: IEShipmentResponse = useSelector(getPayloadforTenderAction());
  const payloadValue = shipmentDetails
                            && shipmentDetails.shipments
                            && shipmentDetails.shipments.length > 0 
                            ? shipmentDetails.shipments[0] : [];
  const myLoadsMaxPageSize = FetchFromMyLoadConfig("PageSize");                          
  useEffect(() => {
    (isOnScreen === true) && props.onScreen && props.onScreen(props.loadId || props.shipmentId, props.rank);
  }, [isOnScreen]);
  const [showMessageForPendingLoad, onShowMessageForPendingLoad] = useState<
    boolean
  >(false);

  const { showMap, setShowMap, predecessorShipmentDetails = {} } = props;
  const gridRef = useRef<any>(null);
  const [toolTip, setTooltip] = useState<any>(null);
  const alerticon = <IonIcon src="assets/icon/alert-app.svg" className="alert-app"
  data-test="alert-app" />


  useEffect(() => {
    if (
      props.history &&
      props.history.location &&
      props.history.location.pathname === CARRIER_ASSIGNED_MODULE_WEB &&
      props.history.location.state &&
      props.history.location.state.isBookLoad
    ) {
      if (!showMap && myload) {
        getShipmentDetails(() => {
          setShowMap(true);
        });
      }
      else setShowMap(false);
    }
  }, []);

  useEffect(() => {
    if (((props?.history?.location?.state?.module === MODULE_PATHS.DRIVER_ASSIGNED) || (props?.history?.location?.state?.module === MODULE_PATHS.INTRANSIT) || (props?.history?.location?.state?.module === MODULE_PATHS.DELIVEREDNEEDSPPWK)|| (props?.history?.location?.state?.module === MODULE_PATHS.DELIVEREDWITHPPWK)) &&
      props?.history?.location?.state?.isManageUserViewLoad
    ) {
      if (!showMap && myload) {
        getShipmentDetails(() => {
          setShowMap(true);
        });
      }
      else setShowMap(false);
    }
  }, []);

  useEffect(() => {
    if (props &&
      props.topRecommLoadClick &&
      props.load.loadId &&
      props.topRecommLoadClick == props.load.loadId) {
      getShipmentDetails(() => {
        setShowMap(true);
      })
    };
  }, [props?.topRecommLoadClick, props?.rowIndex])
  useEffect(() => {
    !(props?.topRecommLoadClick) && showMap && clickDownArrowAction()
  }, [props?.history?.location?.pathname])
  useEffect(() => {
    if (props?.history?.location?.state?.showDriversListFromAddDriver && !!(props?.history?.location?.state?.selectedShipmentId === props.shipmentId)) {
      openDialog(true);
    }
  }, [props?.history?.location?.state])
  useEffect(() => {
    if(props?.history?.location?.state?.isGlobalSearch){
        setShowMap(false);
        setCarrierPro(props.load ? props.load.carrierPro : "")
      }
  }, [props?.history?.location?.state])

  useEffect(() => {
    setCarrierPro(props?.load?.carrierPro ? props.load.carrierPro : "")
  }, [props.load.carrierPro])

  const getLoadStopDetails = (isLoadDetails = false) => {
    let loadStop = [];
    let sortedLoadStops =
      props?.loadStop?.slice().sort((load1: any, load2: any) => {
        if (load1.sequenceNo && load2.sequenceNo) {
          return load1.sequenceNo - load2.sequenceNo;
        }
        if (load1.stopSequence && load2.stopSequence) {
          return load1.stopSequence - load2.stopSequence;
        }
        return 0;
      }) || [];

    if (!props.isCarrierLoad) {
      sortedLoadStops = sortedLoadStops.filter((stop: any) => {
        return stop.stopType !== "NFR";
      });
    }

    if (isLoadDetails) {
      loadStop = sortedLoadStops;
    } else {
      loadStop[0] = sortedLoadStops && sortedLoadStops[0];
      loadStop[1] =
        sortedLoadStops && sortedLoadStops[sortedLoadStops.length - 1];
    }
    return loadStop;
  };

  const isLoadFlag =
    [
      MODULES.INTRANSIT_MODULE,
      MODULES.DRIVER_ASSIGNED_MODULE,
      MODULES.RECENTLY_DELIVERED_MODULE,
      MODULES.CARRIER_ASSIGNED_MODULE,
    ].indexOf(props.module) !== -1;
  const handleCardClick = () => {
    if (isLoadFlag && props.onRowCallback) {
      props.onRowCallback();
    }
  };

  const isMyload = (): boolean => {
    return (
      props.module == MODULES.RECENTLY_DELIVERED_MODULE ||
      props.module == MODULES.INTRANSIT_MODULE ||
      props.module == MODULES.DRIVER_ASSIGNED_MODULE ||
      props.module == MODULES.CARRIER_ASSIGNED_MODULE ||
      props.module == MODULES.DELIVERED_WITH_PPWK_MODULE ||
      props.module == MODULES.CARRIER_TENDERED_MODULE
           );
  };
  const myload = isMyload();
  const lead = (module: any) => {
    if (module === MODULES.SEARCH_RESULTS) {
      return TAB.SEARCHED;
    }
    if (module.indexOf(TAB.RECOMMENDED) !== -1) {
      return TAB.RECOMMENDED;
    }
    if (module.indexOf(TAB.WATCHED) !== -1) {
      return TAB.WATCHED;
    }
  };

  const calculateTime = (stop: any) => {
    if (myload) {
      let _time: string = getAppointmentTime(stop);
      _time = (_time || "")
        .split("AM")
        .join("am")
        .split("PM")
        .join("pm")
        .replace(/Z/g, "")
        .replace(/z/g, "");
      return _time;
    }
    let _newAptTime: string = getTime(
      stop.appointmentFrom || "",
      stop.appointmentTo || ""
    );
    _newAptTime = (_newAptTime || "")
      .split("AM")
      .join("am")
      .split("PM")
      .join("pm")
      .replace(/Z/g, "")
      .replace(/z/g, "");
    return _newAptTime;
  };
  const calculateTimeIndicator = (stops: any[]) => {
    let activity : any= stops?.length > 0 && stops?.find((stop : any) => stop?.sequenceNo === 1)
    if (myload && activity) {
      let _timeIndicator: string| null = getAppointmentIndicatorTime(activity);
      _timeIndicator = _timeIndicator!== null ?(_timeIndicator || "")
        .split("AM")
        .join("am")
        .split("PM")
        .join("pm")
        .replace(/Z/g, "")
        .replace(/z/g, "") : _timeIndicator;
      return _timeIndicator;
    }
  }

  const getShipmentDetails = (callback?: (executedShipmentID?: string) => void) => {
    const shipmentId = executedShipmentID ? executedShipmentID : (props && props.shipmentId) || "";
    const getShipmentmodel: GetShipment = new GetShipment();
    const module = props.module;
    getShipmentmodel.shipmentIds = shipmentId;
    dispatch(
      buyLoadShipmentRequest(
        {
          query: getShipmentmodel.getRequestShipmentPayload(),
          shipmentId,
          module,
          isPullToRefresh: false,
          isGlobalSearch : props?.history?.location?.state?.isGlobalSearch
        },
        callback
      )
    );
    // Analytics implementation
    logEvent(EVENT.SV_VIEW_SHIPMENT, {
      screen: SCREEN.SHIPMENT_DETAILS,
      shipmentId,
    });
  };

  useEffect(() => {
    if (props.toCallExpand) {
      setTimeout(() => {
        setShowMap(true);
      }, 300);
      if (gridRef.current) {
        props.onChangeRowIndex();

      }
    }
  }, [props.toCallExpand]);

  const fetchDriverList = () => {
    openDialog(true);
    const modelList: DriverList = new DriverList();
    const modelListPayload : DriverList = getMembersRequestPayload(modelList,props?.userDetails);
    dispatch(AssignDriver(modelListPayload.getRequestPayload()));

    // Analytics implementation
    logEvent(EVENT.SV_ASSIGN_DRIVER, {
      screen: SCREEN.MYLOADS_DRIVER_ASSIGNMENT,
      carrierId:props.userDetails && props.userDetails.memberDetailsResponse &&
      props.userDetails.memberDetailsResponse.member &&  props.userDetails.memberDetailsResponse.member.carrierId,
    });

  };

  const [selectedIndex, onIndexSelect] = useState<number>(-1);
  const [selectedDriver, onSelectDriver] = useState<any>({});
  const [isCnfOpen, openConfirmDialog] = useState<boolean>(false);
  const [isStartTripCnf, confirmStartTrip] = useState<boolean>(false);
  const [isUnAssign, setUnAssign] = useState<boolean>(false);
  const [isGPSTrackingOn] = useState<boolean>(false);
  const [errorMessage, setErrorMessage] = useState<string>("");
  const [executedShipmentID, setexecutedShipmentID] = useState<string>("");
  const [showMessageForStartTrip, onShowMessageForStartTrip] = useState<boolean>(false);
  const [defaultTab, setDefaultTab] = useState<string>("map");
  const storeData = store.getState();
  const [carrierProError, setCarrierProError] = useState("");
  const session = storeData && storeData.App && storeData.App.session;
  const sessionId = getSessionId(session.uuid);
  const loadDetails = getLoadStopDetails();
  const [showModalforAcceptLoad, setShowModalforAcceptLoad] = useState<boolean>(false);
  const [carrierPro,setCarrierPro] = useState<string>(props.load ? props.load.carrierPro : "");
  const [updatedLoadDetail,setUpdatedLoadDetail] = useState<any>(props?.load)

  const setUnAssignDriverDetails = ()=>{
  
    const getShipmentmodel: GetShipment = new GetShipment();
    const module = props.module;
    getShipmentmodel.shipmentIds = props.load.shipmentId;
    dispatch(
      buyLoadShipmentRequest(
        {
          query: getShipmentmodel.getRequestShipmentPayload(),
          shipmentId: props.load.shipmentId,
          module,
          isPullToRefresh: false,
          isGlobalSearch : props?.history?.location?.state?.isGlobalSearch
        },
        (res:any) =>
        {
          const _shipmentData = res?.getShipment?.length > 0 && res?.getShipment[0];
       if(_shipmentData)
          {
            setUnAssign(true)
            setUpdatedLoadDetail(_shipmentData)
          }
        }
      )
    );
      }
  const handleCarrierProChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if(props?.load?.carrierPro && (e?.target?.value === "" || e?.target?.value.trim() === "")){
      setCarrierProError(IONICWrapper?.details?.keys?.configuration?.carrierProErrorLabel || carrierProErrorLabelFallback);
      setCarrierPro(props?.load?.carrierPro)
    } else {
      carrierProError && setCarrierProError("");
    }
    setCarrierPro(e?.target?.value);
  }

  const onActionClick = (isClicked: boolean, callback?: () => void) => {
    if (props.module == MODULES.CARRIER_TENDERED_MODULE) {
      setShowModalforAcceptLoad(true)
      logEvent(EVENT.CARRIER_TENDERED_ACCEPT, {
        screen:SCREEN.CARRIER_TENDERED,
        shipmentId: props.load && props.load.shipmentId,
        sessionId :sessionId
      });  
    }

    if (props.module == MODULES.CARRIER_ASSIGNED_MODULE) {
            fetchDriverList();

    } else if (props.module == MODULES.DRIVER_ASSIGNED_MODULE) {
      const shipmentId: string = props.shipmentId || "";
      if (callback) {
        callback();
      }
      if (
        props.executionStatus == EXECUTIONSTATUS.STARTED) {
        getShipmentDetails(() => {
          const __nav: { [key: string]: string } = {};
          __nav[MY_LOAD] = `/app/myLoad/Execution/${shipmentId}`;
          dispatch(setNavigation(__nav));
          history.push(`/app/myLoad/Execution/${shipmentId}`, {
            module: props.module,
          });
        });
        // Analytics implementation
        logEvent(EVENT.UE_START_TRIP, {
          screen: SCREEN.SHIPMENT_DETAILS,
          carrierId:props.userDetails && props.userDetails.memberDetailsResponse &&
          props.userDetails.memberDetailsResponse.member &&  props.userDetails.memberDetailsResponse.member.carrierId,
          shipmentId,
        });
      } else {
        if (props.executionStatus != EXECUTIONSTATUS.STARTED) {
          const fetchValue: any = (key: string) =>
            IONICWrapper.details.auth && IONICWrapper.details.auth.user[key];
          const modelExicution: StartTripExicution = new StartTripExicution();
          modelExicution.userId =props.userDetails && props.userDetails.memberDetailsResponse &&
          props.userDetails.memberDetailsResponse.member &&  props.userDetails.memberDetailsResponse.member.upn;
          modelExicution.shipmentId = props && props.shipmentId;
          modelExicution.roles = fetchValue(FETCH_VALUE.ROLES);
          modelExicution.gpsTrackingStatus = EGPSTrackingStatus.GPS_TRACKING_STOPPED;
          modelExicution.carrierId = props.userDetails && props.userDetails.memberDetailsResponse &&
          props.userDetails.memberDetailsResponse.carrierInfo &&  props.userDetails.memberDetailsResponse.carrierInfo.commonCarrierId;
          dispatch(startTrip(modelExicution.startTrip(), (response: any) => {
            if (response.status) {
              const shipmentId: string = response.shipment && response.shipment.shipmentId;
              if (!shipmentId) {
                return;
              }
              const shipment: any = [response.shipment];
              let driverLoad: any[] = props.loadData.driverLoad.map(
                (obj: any) =>
                  shipment.find((o: any) => o.shipmentId === obj.shipmentId) || obj
              );
              dispatch(loadAssignedData(driverLoad, driverLoad.length));
              getShipmentDetails(() => {
                const __nav: { [key: string]: string } = {};
                __nav[MY_LOAD] = `/app/myLoad/Execution/${shipmentId}`;
                dispatch(setNavigation(__nav));
                history.push(`/app/myLoad/Execution/${shipmentId}`, {
                  module: props.module,
                });
              });
            } else {
              onShowMessageForStartTrip(!response.status);
              setErrorMessage(response.message);
              setexecutedShipmentID(response.shipment.shipmentId);
            }
          }));
        }
      }
    } else if (
      props.module == MODULES.INTRANSIT_MODULE ||
      props.module == MODULES.RECENTLY_DELIVERED_MODULE ||
      props.module == MODULES.DELIVERED_WITH_PPWK_MODULE
    ) {
      const shipmentId: string = props.shipmentId || "";
      getShipmentDetails(() => {
        const __nav: { [key: string]: string } = {};
        __nav[MY_LOAD] = `/app/myLoad/Execution/${shipmentId}`;
        dispatch(setNavigation(__nav));

        history.push(`/app/myLoad/Execution/${shipmentId}`, {
          module: props.module,
        });
      });
    }

  };

  const loadId = myload ? props.shipmentId : props.loadId;
  const updatedCarrierTenderedShipments = () => {
    const updated: MyLoad = new MyLoad()
    const _input: any = {
      carrierAssigned: true,
      carrierTendered: true,
      driverAssigned: true,
      inTransit: true,
      deliveredNeedsPaperWork: true,
      deliveredWithPaperWork: true,
    }
    updated.pagination = {
      pageSize: IONICWrapper?.details?.keys?.configuration?.MyLoadsConfig.PageSize.Web || myLoadsMaxPageSize || MyLoadsConfigFallback.PageSize.Web,
      pageIndex:0 ,
     // myLoadPageFilter: null
    }
    updated.filter = _input;
    dispatch(fetchShipments(updated.getCarrierTenderedShipments(), false))
  }
  const navigateToExecutionPage = () => {
    window.sessionStorage.removeItem('stopInfo');
    const shipmentId: string = props.shipmentId || "";
    getShipmentDetails(() => {
      const __nav: { [key: string]: string } = {};
      __nav[MY_LOAD] = `/app/myLoad/Execution/${shipmentId}`;
      dispatch(setNavigation(__nav));
      history.push(`/app/myLoad/Execution/${shipmentId}`, {
        module: props.module,
      });
    });
  }
  const hasSimilarLoads: boolean = !!(props.load.similarLoads && props.load.similarLoads.length)

  const clickDownArrowAction = (isTriggredFromPPWK?: boolean) => {
    if (props.topRecommLoadClick) {
      props.clearTopRecommedLoadDetails(true)
      setShowMap(!showMap);
    }
    if (!showMap && myload) {
      getShipmentDetails((data: any) => {
        if ((props.history && props.history.location && props.history.location.state &&
          props.history.location.state.isGlobalSearch && props.history.location.state.shipmentId)
          && (data && data.getShipment && data.getShipment.length > 0 &&
            data.getShipment[0].shipmentId === props.history.location.state.shipmentId)) {
          props.history.location.state.shipments = data.getShipment;
        }
        setShowMap(!showMap);
      });
    }
    else {
      setShowMap(!showMap);
    }
    isTriggredFromPPWK && setDefaultTab("documents")
  }
  const errorModalProps = {
    isModalOpen: showMessageForStartTrip,
    title: ERROR_POPUP.TITLE,
    message_content : errorMessage,
    contentScroll: "deny",
    size: "extra_small_height",
    buttons: [
      {
        title: BUTTONS.OK,
        type: "primary-cta-btn-web",
        onClick: () => {
          {
            onShowMessageForStartTrip(false);
            if(!(errorMessage.includes("Driver assignment") && errorMessage.includes("is in progress.") 
            && errorMessage.includes(executedShipmentID)))
            {
              getShipmentDetails(() => {
              const __nav: { [key: string]: string } = {};
              __nav[MY_LOAD] = `/app/myLoad/Execution/${executedShipmentID}`;
              dispatch(setNavigation(__nav));
              history.push(`/app/myLoad/Execution/${executedShipmentID}`, {
                module: props.module,
              });
            });
          }
          }
        }
      }
    ]
  }
  const acceptLoadModalProps =
  {
    isModalOpen : showModalforAcceptLoad,
    title: accept_load_modal_title,
    message_header: accept_load_modal_message,
    aditionalCssClass:"accept-load",
    size: carrierProInputBoxVisibility(props?.load?.sourceTMS,props?.load?.division,CARRIER_PRO_TYPE)?"medium_acceptload_carrierpro":"medium_acceptload",
    buttons: [
      {
        title: i18n.t('No'),
        type: "secondary-cta-btn-web",
        onClick: () => {
          logEvent(EVENT.CARRIER_TENDERED_ACCEPT_DENIED, {
            screen:SCREEN.ACCEPT_LOAD,
            shipmentId: props.load && props.load.shipmentId,
            sessionId :sessionId
          });
          setShowModalforAcceptLoad(false);
          setCarrierPro(props?.load?.carrierPro ? props?.load?.carrierPro :"");
          setCarrierProError("");
        }
      },
      {
        title: i18n.t('Yes'),
        isDisabled: carrierProError,
        type: "primary-cta-btn-web",
        onClick: () => {
          const getShipmentmodel: GetShipment = new GetShipment();
              const module = props?.load?.module;
              getShipmentmodel.shipmentIds = props?.load?.shipmentId;
              dispatch(
                buyLoadShipmentRequest(
                  {
                    query: getShipmentmodel.getRequestShipmentPayload(),
                    shipmentId: props?.load?.shipmentId,
                    module,
                    isPullToRefresh: false,
                    isGlobalSearch : props?.load?.history?.location?.state?.isGlobalSearch
                  },
                 (res : any)=>
                 {
                  const _shipmentData = res?.getShipment?.length > 0 && res?.getShipment[0];
                  if(_shipmentData)
                  {
          logEvent(EVENT.CARRIER_TENDERED_ACCEPT_CONFIRMED, {
            screen:SCREEN.ACCEPT_LOAD,
            shipmentId: props.load && props.load.shipmentId,
            sessionId :sessionId
          });
          const _model: any = new TenderAction();
          _model.shipmentId = props.load && props.load.shipmentId;
          _model.sourceSystem = props.load && props.load.sourceTMS;
          _model.eventDateTime = getCurrentDatewithTimeZone(props.load && props.load.loadStop);
          _model.customer = getCustomer(_shipmentData && _shipmentData?.shipmentInvolvedParties);
          _model.assignmentStatus =props.load && props.load.assignmentStatus;
          _model.actionType = ACCEPT_ACTION_TYPE;
          _model.actionDetail = (carrierPro === props?.load?.carrierPro) ? props?.load?.carrierPro?.trim() : carrierPro ? carrierPro?.trim() : null;
          if(props?.load?.carrierPro || carrierPro) {
            _model.actionQualifier = ACCEPT_ACTION_QUALIFIER;
          }
          _model.shipmentState = props.load && props.load.shipmentState || null;
          _model.actionDateTime = null;
          _model.offeredRate = (props?.load?.shipmentTenderedCarriers &&  props?.load?.shipmentTenderedCarriers[0]?.offeredRate ? ( props?.load?.shipmentTenderedCarriers[0]?.offeredRate === 0 ||  props?.load?.shipmentTenderedCarriers[0]?.offeredRate === null)? null : props?.load?.shipmentTenderedCarriers[0]?.offeredRate : null )
          dispatch(tenderAction(_model.getTenderActionPayload(),false,(response: any) => {
            if (response.message === ACCEPT_ACTION_TYPE || response.message === (props.load && props.load.carrierPro || carrierPro)) {
            setShowModalforAcceptLoad(false)
            ToastMessage.showWeb(TENDER_ACCEPT_SUCCESS_MESSAGE);
            updatedCarrierTenderedShipments()   
            }
            else
            {
              ToastMessage.showWeb(response.message);
              setShowModalforAcceptLoad(false);
              const carrierModel: MyLoad = new MyLoad();
              carrierModel.filter = { carrierTendered: true };
              carrierModel.pagination = {
                pageSize: myLoadsMaxPageSize,
                pageIndex: 0,
              };
              dispatch(fetchShipments(carrierModel.getCarrierTenderedShipments(), false));
            }
          }));
                  }
                 }))
        }
      }
    ]
  }
  return (
    <React.Fragment>
      <IonToast
        isOpen={showMessageForPendingLoad}
        message={START_TRIP_MESSAGE_FOR_PENDING_LOADS}
        duration={5000}
        color="dark"
        onDidDismiss={() => {
          onShowMessageForPendingLoad(false);
        }}
      />
      <CustomModalWeb  {...errorModalProps}/>
      <CustomModalWeb {...acceptLoadModalProps}>
      {carrierProInputBoxVisibility(props?.load?.sourceTMS,props?.load?.division,CARRIER_PRO_TYPE) && <div className ="pro-num-visible">
        <IonCol size="6" className="accept-load">
          <div color="dark" className="carrier-pro-labelname">
            {CARRIER_PRO}
          </div>
          <div>
            <input 
              type="text"
              value={(carrierPro === props?.load?.carrierPro) ? props?.load?.carrierPro : carrierPro}
              onChange={handleCarrierProChange}
              placeholder="Enter Carrier PRO"
              className={`carrierProInput ${!!carrierProError ? "error" : ""}`}
            />
            {!!carrierProError &&
              <span className="carrierProErrorLabel">{carrierProError}</span>
            }  
          </div>
        </IonCol>
        </div>}
      </CustomModalWeb>
      <ConfirmStartTrip
        userDetails={props.userDetails}
        open={isStartTripCnf}
        onDismiss={() => {
          confirmStartTrip(false);
        }}
        loadDetails={props.load}
        loadData={props.loadData}
        calculateTime={calculateTime}
        count={props.count}
        GPSTrackingStatus={isGPSTrackingOn}
      />
      {isOpen ? <AssignDriverDialog
        history={props.history}
        loadDetails={loadDetails}
        isOpen={true}
        onDismiss={(close: boolean) => {
          openDialog(false);
          if (!close) {
            openConfirmDialog(true);
          }
        }}
        driverList={props.driverList || []}
        selectedIndex={selectedIndex}
        onIndexSelect={onIndexSelect}
        onSelectDriver={onSelectDriver}
        shipmentId={props.shipmentId}
        driverDetails={selectedDriver}
      /> : null}
      <ConfirmDriverDialog
        userDetails={props.userDetails}
        driverDetails={selectedDriver}
        open={isCnfOpen}
        onDismiss={(cancel: boolean) => {
          openConfirmDialog(false);
          if (!!cancel) {
            openDialog(true);
          }
        }}
        openReloadModal={props.openReLoadModal}
        loadDetails={props}
        loadData={props.loadData}
        calculateTime={calculateTime}
        count={props.count}
        module={props.module}
        predecessorShipmentDetails={predecessorShipmentDetails.predecessorShipmentId}
      />
      <DriverUnAssignment
        showAlert={isUnAssign}
        loadDetails={updatedLoadDetail}
        handleAlert={() => { setUnAssign(false) }}
        module={props.module}
      />
     
      <IonCard ref={eleRef}
        className={`ion-card-updated web-card-height ${hasSimilarLoads && lead(props.module) === TAB.RECOMMENDED ? 'card-content-similar-web' : 'card-content-load-web'}`}
        onClick={handleCardClick}
      >
         <div className ="card-tooltip">
       <ToolTip icon={alerticon} message={toolTip} isActive={!!toolTip} />
       </div>
        <IonCardContent className="card-content">
          <IonGrid class="load-grid" ref={gridRef}>
          {(props.module === Navigate_Module_Web.recommended || props.module === Navigate_Module_Web.watched_load || props.module === Navigate_Module_Web.search || props.module === Navigate_Module_Web.search_results || props.module === Navigate_Module_Web.manage_capacity_see_results|| myload) &&
          (appointmentState(props?.loadStop,props) === APPOINTMENT_INDICATOR_STATE_VALUE) && <IonIcon
               onClick={() => setTooltip(IONICWrapper?.details?.keys?.configuration?.AppointmentModalTooltipMessage || APPOINTMENT_TOOLTIP_MESSAGE)}
               onMouseEnter={() => setTooltip(IONICWrapper?.details?.keys?.configuration?.AppointmentModalTooltipMessage || APPOINTMENT_TOOLTIP_MESSAGE)}
               onMouseLeave={() => setTooltip(null)}
              className="appointment-time-indicator-loadCard"
              src={`assets/icon/appointment-time-indicator.svg`}
          />}
          
            <IonRow>
              <IonCol className="card-price-col web-card-height" size="2.5">
                <ShipmentDetails {...props} loadId={loadId} showLoadNo={true} isMyload={myload} />
              </IonCol>
              <IonCol className="card-city-col" size="7">
                <LoadTileMiddle
                  {...props}
                  loadStop={loadDetails}
                  calculateTime={calculateTime}
                  isMyload={myload}
                />
              </IonCol>
              <IonCol className="load-last-col" size="2.5">
                <LoadTileRight
                  {...props}
                  isMyload={myload}
                  onActionClick={onActionClick}
                  isTripStarted={
                    props.executionStatus == EXECUTIONSTATUS.STARTED || false
                  }
                  deleveredOn={getDeleveredOnDate(props.loadStop || [])}
                  driverAction={(name: string) => {
                    name === UN_ASSIGN_DRIVER_CTA_TEXT ? setUnAssignDriverDetails():
                      name === ASSIGN_DRIVER_CTA_TEXT ?
                        fetchDriverList() : navigateToExecutionPage();
                  }}
                  expandMap={clickDownArrowAction}
                  getShipmentDetails={getShipmentDetails}
                />
              </IonCol>
            </IonRow>
          </IonGrid>
        </IonCardContent>

        {useMemo(() => {
          return showMap && <LoadTileMap
            {...props}
            loadStop={getLoadStopDetails(true)}
            calculateTime={calculateTime}
            show={showMap}
            defaultTab={defaultTab}
            clickDownArrowAction={clickDownArrowAction}
          />
        }
          , [props.load, showMap])}

       {!props?.isManageUserAssignedLoad && <IonIcon
          onClick={() => {
            clickDownArrowAction()
          }}
          className={`matchedLoads-downarrow ${showMap ? "up" : "down"}`}
          data-test="show-map-arrow"
          src={`assets/icon/grid-${showMap ? "up" : "down"}-arrow-thin.svg`}
        />}
      </IonCard>
    </React.Fragment>
  );
};

export default LoadTile;
